import React from 'react';

import { DotSpinner } from '~components/commons/spinners/DotSpinner';

import styles from './Folded2025Loader.module.scss';

const Folded2025Loader = (): JSX.Element => {
	return (
		<div className={styles.loader}>
			<DotSpinner />
		</div>
	);
};

export default Folded2025Loader;
